import dataApi from '../'

export default {

  /**
  * Get uuser info for login
  */
  getWhoAmI () {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/who-am-i'
    })
  },

  /**
  * Get user roles that loggedInUser is allowed to add
  */
  getRoles () {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/roles'
    })
  },

  /**
  * Get user roles that may be used for Cit workflow log in
  */
  getCitRoles () {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/cit-roles'
    })
  },

  /**
  * Get user info
  */
  getGet (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/get',
      params: params
    })
  },

  /**
  * Get all users
  */
  getOverview (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/overview',
      params: params
    })
  },

  /**
* Get users by unit
*/
  getOverviewByUnit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/overview-by-unit',
      params: params
    })
  },

  /*
  * Add user
  */
  postAdd (params) {
    return dataApi.request({
      method: 'post',
      url: 'ui/user/add',
      body: params
    })
  },

  /**
  * Delete user
  */
  deleteDelete (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/user/delete',
      params: params
    })
  },

  /**
  * Unlock user
  */
  unlock (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/user/unlock',
      params: params
    })
  },

  /**
  * Get the unit info for edit
  */
  getInforForEdit (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/info-for-edit',
      params: params
    })
  },

  /**
  * Edit unit
  */
  putEdit (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/user/edit',
      body: params
    })
  },

  /**
  * Get users based on a search value
  */
  getSearch (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/search',
      params: params
    })
  },

  /**
  * Get logged in user role permissions
  */
  getUserPermissions (params) {
    return dataApi.request({
      method: 'get',
      url: 'ui/user/userpermissions',
      params: params
    })
  },

  /**
  * Change logged in user password
  */
  putChangePassword (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/user/change-password',
      body: params
    })
  },

  /**
  * Change logged in user pin
  */
  putChangePin (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/user/change-pin',
      body: params
    })
  },

  /**
  * Update loggd in user nama/surname
  */
  putUpdateProfile (params) {
    return dataApi.request({
      method: 'put',
      url: 'ui/user/update-profile',
      body: params
    })
  },

  /**
   * Reset user secret state.
   * @param {userUuid} userUUID
   * @returns
   */
  resetQrSecret (userUUID) {
    return dataApi.request({
      method: 'post',
      url: 'ui/v2/reset-secret/' + userUUID,
      body: ''
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/user.js